import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import Slider from 'react-slick'
import s from './index.css';
import Link from '../../common/Link'
import BlurImg from '../../common/BlurImg'
import { trackEventLog } from '../../../core/utils'
import bannerDefault from '../../common/static/bannerDefault.jpg'
import IconLeftNav from './ic_left.png'
import IconRightNav from './ic_right.png'

const slideSetting = {
  dots: true,
  arrows: false,
  infinite: false,
  autoplay: false,
  slidesToShow: 1,
  slidesToScroll: 1,
}

const slickDotsStyle = `
  .comp-slide .slick-slider {
    position: relative;
  }
  .comp-slide .slick-dots button {
    display: none;
  }
  .comp-slide .slick-dots{
    position:absolute;
    height: 2px;
    top: 338px;
    left: 0;
    width: 1180px;
    text-align: center;
  }
  .comp-slide .slick-dots li{
    display: inline-block;
    height: 2px;
    width: 30px;
    background: rgba(255, 255, 255, 0.5);
    line-height: 2px;
    vertical-align: top;
    margin: 0 2px;
    border-radius: 2px;
  }
  .comp-slide .slick-dots .slick-active {
    background: #fff;
  }
  .comp-slide .slick-arrow {
    position: absolute;
    top: 150px;
    height: 60px;
    width: 36px;
    background: rgba(0, 0, 0, 0.1);
    z-index: 10;
    display: none !important;
    cursor: pointer;
  }
  .comp-slide .slick-slider:hover .slick-arrow {
    display: block !important;
  }
  .comp-slide .slick-prev {
    left: 0;
    background: rgba(0, 0, 0, 0.1) url(${IconLeftNav}) center center no-repeat;
  }
  .comp-slide .slick-arrow:hover {
    background: rgba(0, 0, 0, 0.3) url(${IconLeftNav}) center center no-repeat;
  }
  .comp-slide .slick-next {
    right: 0;
    background: rgba(0, 0, 0, 0.1) url(${IconRightNav}) center center no-repeat;
  }
  .comp-slide .slick-next:hover {
    background: rgba(0, 0, 0, 0.3) url(${IconRightNav}) center center no-repeat;
  }
  .comp-slide img {
    border-radius: 4px;
  }
`


class Slide extends React.Component {

  static propTypes = {
    banners: PropTypes.array.isRequired,
    inLocPrefix: PropTypes.string.isRequired,
    inLocPosfix: PropTypes.string,
    tagId: PropTypes.string,
  }

  static defaultProps = {
    inLocPosfix: '',
    tagId: '',
  }

  render() {
    const { banners, inLocPrefix, inLocPosfix, tagId } = this.props
    let settings = slideSetting
    if (banners.length > 1) {
      settings = Object.assign({}, slideSetting, {
        infinite: true,
        speed: 500,
        arrows: true,
        autoplay: true,
        prevArrow: <div {...this.props} />,
        nextArrow: <div {...this.props} />,
      })
    }
    const style = `
      ${slickDotsStyle}`
    return (
      <div className={'comp-slide'}>
        <style dangerouslySetInnerHTML={{ __html: style.replace(/\t|\s{2,}/gi, '') }} />
        {banners.length > 0 && <Slider {...settings}>
          {banners.map((banner, inx) => (
            <Link
              // 没有id的数据通过特殊前缀+索引来保持唯一性
              key={`slide_${banner.id ? banner.id : `index_${inx}`}`}
              to={banner.url}
              target={'_blank'}
              rel={'noopener noreferrer'}
              className={s.link}
              extraParams={{ inLoc: `${inLocPrefix}${inx}${inLocPosfix}` }}
              onClick={() => { trackEventLog(tagId ? `w/tag/${tagId}/head/${inx}` : `w/index/slider/click/${inx}`) }}
            >
              <BlurImg
                addStyle={s.img}
                placeHolder={bannerDefault}
                originSrc={banner.img}
                altText={banner.title}
              />
            </Link>))}
        </Slider>}
      </div>
    );
  }
}

export default withStyles(s)(Slide);



// WEBPACK FOOTER //
// ./src/components/common/Slide/index.js